import {
  SETTLEMENT_REPORT_SUCCESS,
  SETTLEMENT_REPORT_FAILED,
  RESET_SETTLEMENT_REPORT,
  LOADING_SETTLEMENT_REPORT,
  NETWORK_ERROR_SETTLEMENT_REPORT,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SETTLEMENT_REPORT: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case SETTLEMENT_REPORT_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case SETTLEMENT_REPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_SETTLEMENT_REPORT: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        networkError: true,
        data: {},
      };
    }
    case RESET_SETTLEMENT_REPORT: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
